import { useRef } from "react";
import { isFunction } from "lodash";
import type { FieldValues, UseFormTrigger } from "react-hook-form";

export const useValidateFormSteps = () => {
  const triggerValidationRef = useRef<UseFormTrigger<FieldValues> | null>(null);

  const validateAndContinue = async (continueFunction: () => void) => {
    if (isFunction(triggerValidationRef.current)) {
      const hasValidationResult = await triggerValidationRef.current();
      if (!hasValidationResult) {
        return;
      }
    }

    continueFunction();
  };

  return {
    validateAndContinue,
    triggerValidationRef,
  };
};
